const basePath = 'https://files.keithmcmillen.com/products/k-board/'

export default {
  base: basePath,
  // editor version, firmare version, firmware path
  firmwareCurrentVersion: basePath + "firmware/currentVersion.json",
  firmwareCurrentVersionBetas: basePath + "firmware/currentVersionBetas.json",

  editorCurrentVersion: basePath + "editor/currentVersion.json",
  editorCurrentVersionBetas: basePath + "editor/currentVersionBetas.json"
}
